function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.768 7.268l-4.036-4.036a2.5 2.5 0 00-1.768-.732H6.5a2 2 0 00-2 2v15a2 2 0 002 2H16V20H6.5a.5.5 0 01-.5-.5v-15a.5.5 0 01.5-.5h6v3.5a2 2 0 002 2H18v10a.5.5 0 01-.5.5H16v1.5h1.5a2 2 0 002-2V9.036a2.501 2.501 0 00-.732-1.768zM14 7.5V4.621L17.379 8H14.5a.5.5 0 01-.5-.5z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M8 13.25h8M8 16.25h8"
});

function SvgDocumentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgDocumentIcon;